Styxie.Initializers.Global = {
  index: (data) => {
    data.gbName = data.appCodename === 'linda' ? 'GrowthBooster' : 'GeoBooster'
    Styxie.WLC = data
  }
}
